<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { isMobile } from '@/components/util/equipmentUtil.js'
export default {
  name: 'app',
  mounted() {
    this.setBaseFontSize()
  },
  methods: {
    setBaseFontSize() {
      let baseFontSize = isMobile ? 'calc(100vw * 37.5 / 375)' : 'calc(100vw * 14 / 1920)';
      // 设置body、html的font-size
      document.getElementsByTagName('body')[0].style.fontSize = baseFontSize;
      document.getElementsByTagName('html')[0].style.fontSize = baseFontSize;
    },
  }
}
</script>

<!--自定义字体文件、reset样式文件-->
<style lang="less">
@import url('~@/assets/font/my-front.css');
@import url('~@/assets/css/reset.css');
</style>
<style>
* {
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  width: 100%;
  /* font-size: 14px; */
  /* min-width: 1300px; */
}

div {
  box-sizing: border-box;
  word-break: break-all;
  /*正如其名字，所有的都换行。毫不留情，一点空隙都不放过，会把英文单词截断。*/
  word-wrap: break-word;
  /*和上面比 会将英文单词视为整体*/
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: PingFang-SC-Regular, DIN-BlackItalic, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  position: relative;
}

/*router进度条颜色*/
#nprogress .bar {
  background: red !important;
  height: 2px !important;
}

/*  滚动条*/
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  /*width: 9px;*/
  /*height: 10px;*/
}

::-webkit-scrollbar-thumb {
  background-color: rgba(10, 149, 149, 0.16);
  border-radius: 3px;
}
</style>
